import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-3" }
const _hoisted_2 = { class: "relative items-center py-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "relative items-center py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_multi_json_input = _resolveComponent("multi-json-input")!
  const _component_tags_input = _resolveComponent("tags-input")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
  }, [
    _createVNode(_component_form_divider, null, {
      default: _withCtx(() => [
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
          errorMessage: _ctx.v$?.formData['name']?.$errors[0]?.$message,
          isError: _ctx.v$?.formData['name']?.$error,
          required: true,
          label: "Name"
        }, null, 8, ["modelValue", "errorMessage", "isError"]),
        _createElementVNode("div", _hoisted_1, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Connection type", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.formData.config.connectionType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.config.connectionType) = $event)),
            options: _ctx.connectionTypeOptions,
            reduce: (spot) => spot.id,
            class: "mt-1",
            label: "name",
            clearable: false
          }, null, 8, ["modelValue", "options", "reduce"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "MQTT protocol version", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.formData.config.mqttProtocolVersion,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.config.mqttProtocolVersion) = $event)),
            options: _ctx.mqttProtocolVersionOptions,
            reduce: (spot) => spot.id,
            class: "mt-1",
            label: "name",
            clearable: false
          }, null, 8, ["modelValue", "options", "reduce"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`grid ${
          _ctx.formData.config.connectionType === 'TCP'
            ? 'grid-cols-2 space-x-4'
            : 'grid-cols-1'
        } `)
        }, [
          _createVNode(_component_input_field, {
            modelValue: _ctx.formData.config.endpoint,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.config.endpoint) = $event)),
            errorMessage: _ctx.v$?.formData?.config['endpoint']?.$errors[0]?.$message,
            isError: _ctx.v$?.formData?.config['endpoint']?.$error,
            required: true,
            label: "Endpoint"
          }, null, 8, ["modelValue", "errorMessage", "isError"]),
          (_ctx.formData.config.connectionType === 'TCP')
            ? (_openBlock(), _createBlock(_component_input_field, {
                key: 0,
                modelValue: _ctx.formData.config.port,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.config.port) = $event)),
                errorMessage: _ctx.v$?.formData?.config['port']?.$errors[0]?.$message,
                isError: _ctx.v$?.formData?.config['port']?.$error,
                required: true,
                label: "Port",
                type: "number"
              }, null, 8, ["modelValue", "errorMessage", "isError"]))
            : _createCommentVNode("", true)
        ], 2),
        _createVNode(_component_checkbox_input, {
          modelValue: _ctx.formData.config.hasCredentials,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.config.hasCredentials) = $event)),
          "is-checked": _ctx.formData.config.hasCredentials,
          label: "Has credentials"
        }, null, 8, ["modelValue", "is-checked"]),
        (_ctx.formData.config.hasCredentials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_input_field, {
                modelValue: _ctx.formData.config.credentials.username,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.config.credentials.username) = $event)),
                errorMessage: 
            _ctx.v$?.formData?.config?.credentials['username']?.$errors[0]?.$message
          ,
                isError: _ctx.v$?.formData?.config['port']?.$error,
                required: true,
                label: "Username"
              }, null, 8, ["modelValue", "errorMessage", "isError"]),
              _createVNode(_component_input_field, {
                modelValue: _ctx.formData.config.credentials.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.config.credentials.password) = $event)),
                errorMessage: 
            _ctx.v$?.formData?.config?.credentials['password']?.$errors[0]?.$message
          ,
                isError: _ctx.v$?.formData?.config['port']?.$error,
                required: true,
                label: "Password",
                type: "password"
              }, null, 8, ["modelValue", "errorMessage", "isError"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_checkbox_input, {
          modelValue: _ctx.formData.config.isWithCleanSession,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.config.isWithCleanSession) = $event)),
          "is-checked": _ctx.formData.config.isWithCleanSession,
          label: "Clean session"
        }, null, 8, ["modelValue", "is-checked"]),
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.config.topic,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.config.topic) = $event)),
          errorMessage: _ctx.v$?.formData?.config['topic']?.$errors[0]?.$message,
          isError: _ctx.v$?.formData?.config['topic']?.$error,
          required: true,
          label: "Topic",
          onKeyup: _ctx.trimTopic
        }, null, 8, ["modelValue", "errorMessage", "isError", "onKeyup"]),
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "QOS", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.formData.config.qos,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.config.qos) = $event)),
            options: _ctx.qosOptions,
            reduce: (spot) => spot.id,
            class: "mt-1",
            label: "name",
            clearable: false
          }, null, 8, ["modelValue", "options", "reduce"])
        ]),
        _createVNode(_component_checkbox_input, {
          modelValue: _ctx.formData.config.isWithRetainFlag,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.config.isWithRetainFlag) = $event)),
          "is-checked": _ctx.formData.config.isWithRetainFlag,
          label: "Retain flag"
        }, null, 8, ["modelValue", "is-checked"]),
        _createVNode(_component_multi_json_input, {
          onInput: _ctx.handleTopicChange,
          topics: _ctx.formData.config.topicToChannel
        }, null, 8, ["onInput", "topics"]),
        _createVNode(_component_tags_input, {
          label: _ctx.$t('Integrations.Channels'),
          tags: _ctx.formData.config.channels,
          onOnTagMutate: _cache[12] || (_cache[12] = (tags) => (_ctx.formData.config.channels = tags))
        }, null, 8, ["label", "tags"]),
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.executionOrder,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.executionOrder) = $event)),
          label: _ctx.$t('Integrations.ExecutionOrder'),
          type: "number",
          errorMessage: _ctx.v$?.formData['executionOrder']?.$errors[0]?.$message,
          isError: _ctx.v$?.formData['executionOrder']?.$error
        }, null, 8, ["modelValue", "label", "errorMessage", "isError"]),
        _createVNode(_component_checkbox_input, {
          modelValue: _ctx.formData.isActive,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.isActive) = $event)),
          "is-checked": _ctx.formData.isActive,
          label: "Active"
        }, null, 8, ["modelValue", "is-checked"])
      ]),
      _: 1
    }),
    _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
  ], 32))
}